import { Route, createPageRoute } from '@lumapps/router';
import { AppId } from '@lumapps/router/constants';

export const webviewSearchRoute: Route = createPageRoute({
    slug: 'search/:query?/:filter?',
    appId: AppId.webview,
});
